import TypoGraphy from "@/typography";
import { projectImages } from "public/Assets/Images";
import { useState } from "react";
import './index.scss';
import useViewType from "@/utils/Hooks/useViewType";
const ContentsCard = ({
  headings,
  closehandler
}: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const data: any = headings;
  const isMobile = useViewType();
  return !isMobile && <div className="table_of_content_wrapper">
            <div className="table_of_content_trigger" onClick={() => setIsOpen(!isOpen)}>
                <TypoGraphy tagName='h3' text="Table of Contents" variant='Condensed/Desktop/Heading 2 | M | 24 | 120'></TypoGraphy>
                <img src={projectImages.faqArrowDown} alt="arrow_down" style={{
        transform: isOpen ? "rotate(180deg)" : ""
      }} />
            </div>
            {isOpen && <div className="content_list">
                {data.map((item: any, index: number) => <div style={{
        marginBottom: '12px'
      }}><a href={`#${item.anchor}`} className="content-list" key={`category_${index}`}>
                  <TypoGraphy variant='Desktop/Body 2/R | 14 |120' text={`${index + 1}. ${item.heading}`}></TypoGraphy></a></div>)}
            </div>}
        </div> || isMobile && <div className="table_of_content_wrapper">
            <div className="table_of_content_trigger">
                <TypoGraphy tagName='h3' text="Table of Contents" variant='Condensed/Desktop/Heading 2 | M | 24 | 120'></TypoGraphy>
            </div>
             <div className="content_list">
             {data?.map((item: any, index: number) => <div style={{
        marginBottom: '12px'
      }} onClick={() => {
        if (closehandler) {
          closehandler();
        }
      }}><a href={`#${item.anchor}`} className="content-list" key={`category_${index}`}>
                  <TypoGraphy variant='Desktop/Body 2/R | 14 |120' text={`${index + 1}. ${item.heading}`}></TypoGraphy></a></div>)}
            </div>
        </div>;
};
export default ContentsCard;